export default "__VITE_ASSET__77BVYRVl__"